module.exports = __webpack_public_path__ + "img/lt-arrow-right-moutarde.4cc52648.svg";